// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const BooleanIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="BooleanIcon" ref={forwardedRef} {...props}>
      <path d="M6.75 7.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" />
      <path d="M1 10a5.75 5.75 0 0 1 5.75-5.75h6.5a5.75 5.75 0 0 1 0 11.5h-6.5A5.75 5.75 0 0 1 1 10m5.75-4.25a4.25 4.25 0 0 0 0 8.5h6.5a4.25 4.25 0 0 0 0-8.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const BooleanIcon = /* @__PURE__ */ Object.assign(BooleanIconComponent, {
  displayName: 'BooleanIcon',
});
